export default "__VITE_ASSET__605aac40__"